import axios from 'axios';

const fetchOrderPdf = operation => {
  return axios.post('/api/order/generate-simulation-pdf', {
    order: operation,
  });
};

export default fetchOrderPdf;
